import axios from 'axios';

import { CLOUDINARY_API_URL } from '@/constants/urls';
import apiRequest from '@/services/apiRequest';
import { getCoreApi } from '@/utility/getCoreApi';

const BASE_URL = getCoreApi();

interface ICloudImage {
  asset_id: string;
  bytes: number;
  created_at: string;
  etag: string;
  format: string;
  height: number;
  original_filename: string;
  placeholder: boolean;
  public_id: string;
  resource_type: string;
  secure_url: string;
  signature: string;
  tags: string[];
  type: string;
  url: string;
  version: number;
  version_id: string;
  width: number;
}

const getUploadParams = async (path: string, transformation?: string) => {
  const url = '/uploads/sign';
  const folder = `${process.env.cloudinaryRoot}/${path}`;

  const response = await apiRequest<{ timestamp: string; signature: string }>({
    url: `${BASE_URL}${url}`,
    method: 'GET',
    params: { folder, transformation },
  });

  const data = {
    api_key: process.env.cloudinaryKey,
    timestamp: response?.timestamp,
    signature: response?.signature,
    folder,
    transformation,
  } as Record<string, string | File>;

  return { url: CLOUDINARY_API_URL, data };
};

export const uploadImage = async (file: File, path: string) => {
  // Determine resource type and transformation based on file type
  let resourceType = 'image';
  let transformation: string | undefined = 't_upload_scaling';

  if (file.type.startsWith('video/')) {
    resourceType = 'video';
    transformation = undefined;
  } else if (!file.type.startsWith('image/')) {
    resourceType = 'raw';
    transformation = undefined;
  }

  const { url, data } = await getUploadParams(path, transformation);

  // Update URL to use the correct resource type
  const uploadUrl = url.replace('/image/upload', `/${resourceType}/upload`);

  data['Content-Type'] = file.type;
  data.file = file;

  const formData = new FormData();
  for (const [key, value] of Object.entries(data)) {
    if (value !== undefined && value !== null) {
      formData.append(key, value as string | Blob);
    }
  }

  const { data: responseImage } = await axios.post<ICloudImage>(uploadUrl, formData);

  return responseImage;
};
